import React from "react";
import { Box, Button, Inline, Text } from "@origin-digital/ods-core";
import styled from "styled-components";
import { Z_INDEX } from "../../consts/style";

export interface IMasqueradeBannerView {
  showButton: boolean;
}

const StickyBannerContainer = styled.div`
  z-index: ${Z_INDEX.MASQUERADE_BANNER};
  position: sticky;
  top: 0;
`;

export const MasqueradeBannerView = ({ showButton }: IMasqueradeBannerView) => (
  <StickyBannerContainer>
    <Box
      backgroundColor="#721CE3"
      paddingY="xsmall"
      paddingX={["medium", "large"]}
      data-id="masquerade-banner"
    >
      <Inline alignY="center" space="medium" alignX={["left", "center"]}>
        <Text tone={"white" as any}>
          Warning, you are currently masquerading a user.
        </Text>
        {showButton && (
          <Button
            data-id="agent-ui-button"
            size="small"
            color="secondaryB"
            inverse
            target="_blank"
            href="/agent"
          >
            Profile
          </Button>
        )}
      </Inline>
    </Box>
  </StickyBannerContainer>
);
